export type Title = 'Mr' | 'Mrs' | 'Ms' | 'Miss' | 'Unknown'

export const mapToTitle = (title?: string): Title => {
  if (!title) return 'Unknown'

  switch (title.toLowerCase()) {
    case 'mr':
      return 'Mr'
    case 'mrs':
      return 'Mrs'
    case 'ms':
      return 'Ms'
    case 'miss':
      return 'Miss'
    default:
      return 'Unknown'
  }
}
